import React from 'react';

const ReportDesignerPage = () => {
  // Update this to match your running ASP.NET Core API base URL
  const apiBaseUrl = 'http://192.168.70.203:7027'; 

  return (
    <div style={{ width: '100vw', height: '100vh', margin: 0, padding: 0, overflow: 'hidden' }}>
      <iframe
        src={`${apiBaseUrl}/report-designer`}
        title="FastReport Online Designer"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
        }}
      />
    </div>
  );
};

export default ReportDesignerPage;